import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, isRef as _isRef, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "title-count"
};
const _hoisted_2 = {
  class: "title-count"
};
const _hoisted_3 = {
  class: "title-count"
};
const _hoisted_4 = {
  key: 1,
  class: "out-of-stock-titles"
};
const _hoisted_5 = ["src"];
import { ref, watch, reactive, onMounted } from 'vue';
import { showToast } from 'vant';
import { useI18n } from 'vue-i18n';
import constants from '@/constants';
import cartUtils from '../cartUtils';
import CartItem from './CartItem.vue';
import { useRouter } from 'vue-router';
import CartEmpty from './CartEmpty.vue';
import { useLess } from '@/models/hooks';
import imageLink from '@/configs/imageLink';
import { getAppConfig } from '@/utils/common';
import { cartTabsUtilsFun } from './CartTabsUtils';
import { clickEvents } from '@/configs/awsRumConfig';
import { getPromotionList } from '@/utils/newUserCoupon';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import ShareApp from '@/components/shareApp/ShareApp.vue';
import CartItemsRemovedFromShelves from './CartItemsRemovedFromShelves.vue';
import BuyingOptionsPopup from '@/components/buyingOptionsPopup/BuyingOptionsPopup.vue';
export default {
  __name: 'CartTabs',
  props: {
    cptPopupHeight: {
      type: Number,
      require: true,
      default: () => 0
    }
  },
  setup(__props) {
    useLess('views/cart/components/CartTabs.less');
    const {
      APP_CONFIG_TYPES
    } = constants.Common;
    const {
      SELECTED,
      NOT_SELECTED,
      SUCCESS_ICON_IMAGE_URL
    } = imageLink;
    const {
      t
    } = useI18n();
    const router = useRouter();
    const cartTabsRef = reactive([]);
    const asinStocksReminder = ref(null);
    const couponList = ref([]);

    // Shopping cart data processing function
    const {
      cartData,
      isLoading,
      activeTab,
      ACTIVE_NAME,
      isManagement,
      allProductData,
      outOfStockData,
      reducePriceData,
      CART_TABS_INDEX,
      isHiddenBottomArea,
      alreadySoldOutData,
      selectAllOutOfStock,
      dotdOrSpecialSaleProductData
    } = cartUtils.cartState;
    const {
      getAndUpdateData,
      onUpdateItemCount,
      onUpdateItemCheck,
      onClickAllOutOfStock
    } = cartUtils.handleCartState;
    const {
      isShowShareApp,
      shareConfiguration,
      selectProductParams
    } = cartTabsUtilsFun(cartData, isLoading).cartTabsState;
    const {
      onShareItem,
      onDeleteItem,
      onSelectProduct,
      onAddToFavorite,
      onRemoveFavorite,
      onCountDownFinish
    } = cartTabsUtilsFun(cartData, isLoading).handleCartTabsState;

    // Select the product callback data={count, asin, price}
    const onProductOnConfirm = () => {
      showToast({
        message: t('common.SUCCESS_ADDED_CART'),
        icon: SUCCESS_ICON_IMAGE_URL,
        overlay: false,
        overlayClass: 'a-overlay-white',
        className: 'a-toast'
      });
      getAndUpdateData();
    };

    // Jump details
    const onToDetail = asinId => {
      awsRumHandler.recordClickEvent({
        ...clickEvents.cartPage.goToProductDetail_btn,
        asinid: asinId
      });
      isHiddenBottomArea.value = true;
      router.push({
        name: 'detailPage',
        params: {
          asinId
        }
      });
    };

    // Track tabs click data
    watch(activeTab, value => {
      switch (value) {
        case ACTIVE_NAME.DOTD:
          awsRumHandler.recordClickEvent(clickEvents.cartPage.filterDOTD_btn);
          break;
        case ACTIVE_NAME.REDUCE_THE_PRICE:
          awsRumHandler.recordClickEvent(clickEvents.cartPage.filterPriceDrop_btn);
          break;
        case ACTIVE_NAME.ALREADY_SOLD_OUT:
          awsRumHandler.recordClickEvent(clickEvents.cartPage.filterOutOfStock_btn);
          break;
        default:
          break;
      }
    });
    const getAsinStocksReminder = async () => {
      const configData = await getAppConfig(APP_CONFIG_TYPES.SETTING_PAGE);
      asinStocksReminder.value = configData.asinStocksReminder;
    };
    onMounted(() => {
      cartTabsRef.forEach(item => {
        item.style.width = `${item.offsetWidth}px`;
        item.style.whiteSpace = 'nowrap';
      });
      getAsinStocksReminder();
      // Get a list of discount coupons
      getPromotionList(data => {
        couponList.value = data || [];
      });
    });
    return (_ctx, _cache) => {
      const _component_van_tab = _resolveComponent("van-tab");
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _component_van_tabs = _resolveComponent("van-tabs");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_tabs, {
        class: "cart-tab-select",
        active: _unref(activeTab),
        "onUpdate:active": _cache[1] || (_cache[1] = $event => _isRef(activeTab) ? activeTab.value = $event : null),
        "lazy-render": false
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          name: _unref(ACTIVE_NAME).ALL
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).ALL] = el
          }, _toDisplayString(_ctx.$t('modules.cart.ALL')), 513)]),
          default: _withCtx(() => [!_unref(allProductData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyTextPartOne: _ctx.$t('modules.cart.SHOPPING_CART_IS_EMPTY'),
            emptyTextPartTwo: _ctx.$t('modules.cart.ADD_YOUR_FAVOURITE_ITEM_IN_IT'),
            showButton: true
          }, null, 8, ["emptyTextPartOne", "emptyTextPartTwo"])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(allProductData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              couponList: couponList.value,
              isManagement: _unref(isManagement),
              asinStocksReminder: asinStocksReminder.value,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnSelectProduct: _unref(onSelectProduct),
              onOnShareItem: _unref(onShareItem),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnCountDownFinish: _unref(onCountDownFinish)
            }, null, 8, ["item", "couponList", "isManagement", "asinStocksReminder", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnSelectProduct", "onOnShareItem", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnCountDownFinish"]);
          }), 128))]),
          _: 1
        }, 8, ["name"]), _createVNode(_component_van_tab, {
          title: `${_ctx.$t('modules.cart.DOTD_OR_SPECIAL_SALE_EVENT') + ' ' + _unref(dotdOrSpecialSaleProductData).length}`,
          name: _unref(ACTIVE_NAME).DOTD
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).DOTD_OR_SPECIAL_SALE_EVENT] = el
          }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.DOTD_OR_SPECIAL_SALE_EVENT')) + " ", 1), _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(dotdOrSpecialSaleProductData).length), 1)], 512)]),
          default: _withCtx(() => [!_unref(dotdOrSpecialSaleProductData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyText: _ctx.$t('modules.cart.CART_NO_DOTD_OR_SPECIAL_SALE_EVENT_ITEM')
          }, null, 8, ["emptyText"])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(dotdOrSpecialSaleProductData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              couponList: couponList.value,
              isManagement: _unref(isManagement),
              asinStocksReminder: asinStocksReminder.value,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnSelectProduct: _unref(onSelectProduct),
              onOnShareItem: _unref(onShareItem),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnCountDownFinish: _unref(onCountDownFinish)
            }, null, 8, ["item", "couponList", "isManagement", "asinStocksReminder", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnSelectProduct", "onOnShareItem", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnCountDownFinish"]);
          }), 128))]),
          _: 1
        }, 8, ["title", "name"]), _createVNode(_component_van_tab, {
          name: _unref(ACTIVE_NAME).REDUCE_THE_PRICE
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).REDUCE_THE_PRICE] = el
          }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.REDUCE_THE_PRICE')) + " ", 1), _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(reducePriceData).length), 1)], 512)]),
          default: _withCtx(() => [!_unref(reducePriceData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyText: _ctx.$t('modules.cart.CART_NO_REDUCETHEPRICE_ITEM')
          }, null, 8, ["emptyText"])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(_unref(reducePriceData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              couponList: couponList.value,
              asinStocksReminder: asinStocksReminder.value,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnSelectProduct: _unref(onSelectProduct),
              onOnShareItem: _unref(onShareItem),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnCountDownFinish: _unref(onCountDownFinish)
            }, null, 8, ["item", "couponList", "asinStocksReminder", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnSelectProduct", "onOnShareItem", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnCountDownFinish"]);
          }), 128))]),
          _: 1
        }, 8, ["name"]), _createVNode(_component_van_tab, {
          title: _ctx.$t('modules.cart.ALREADY_SOLD_OUT') + ' ' + (_unref(alreadySoldOutData).length + _unref(outOfStockData).length),
          name: _unref(ACTIVE_NAME).ALREADY_SOLD_OUT
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            ref: el => cartTabsRef[_unref(CART_TABS_INDEX).ALREADY_SOLD_OUT] = el
          }, [_createTextVNode(_toDisplayString(_ctx.$t('modules.cart.ALREADY_SOLD_OUT')) + " ", 1), _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(alreadySoldOutData).length + _unref(outOfStockData).length), 1)], 512)]),
          default: _withCtx(() => [!_unref(alreadySoldOutData).length && !_unref(outOfStockData).length ? (_openBlock(), _createBlock(CartEmpty, {
            key: 0,
            emptyText: _ctx.$t('modules.cart.CART_NO_ALREADYSOLDOUT_ITEM')
          }, null, 8, ["emptyText"])) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_unref(alreadySoldOutData).length ? (_openBlock(), _createBlock(CartItemsRemovedFromShelves, {
            key: 0,
            removedData: _unref(alreadySoldOutData),
            onUpdateCheck: _unref(onUpdateItemCheck)
          }, null, 8, ["removedData", "onUpdateCheck"])) : _createCommentVNode("", true), _unref(outOfStockData).length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_checkbox, {
            class: "radio",
            modelValue: _unref(selectAllOutOfStock),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(selectAllOutOfStock) ? selectAllOutOfStock.value = $event : null),
            "checked-color": "#eb1745",
            onClick: _unref(onClickAllOutOfStock)
          }, {
            icon: _withCtx(checkboxProps => [_createElementVNode("img", {
              src: checkboxProps.checked ? _unref(SELECTED) : _unref(NOT_SELECTED)
            }, null, 8, _hoisted_5)]),
            _: 1
          }, 8, ["modelValue", "onClick"]), _createTextVNode(" " + _toDisplayString(_ctx.$t('modules.cart.OUT_OF_STOCK_AT_PRESENT')), 1)])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(outOfStockData), item => {
            return _openBlock(), _createBlock(CartItem, {
              class: "cart-product-item",
              key: item.asin,
              item: item,
              isManagement: true,
              onOnToDetail: onToDetail,
              onOnDeleteItem: _unref(onDeleteItem),
              onUpdateCount: _unref(onUpdateItemCount),
              onUpdateCheck: _unref(onUpdateItemCheck),
              onOnAddToFavorite: _unref(onAddToFavorite),
              onOnRemoveFavorite: _unref(onRemoveFavorite),
              onOnShareItem: _unref(onShareItem)
            }, null, 8, ["item", "onOnDeleteItem", "onUpdateCount", "onUpdateCheck", "onOnAddToFavorite", "onOnRemoveFavorite", "onOnShareItem"]);
          }), 128))], 64))]),
          _: 1
        }, 8, ["title", "name"])]),
        _: 1
      }, 8, ["active"]), _unref(isShowShareApp) ? (_openBlock(), _createBlock(ShareApp, {
        key: 0,
        style: _normalizeStyle({
          marginBottom: __props.cptPopupHeight + 'px'
        }),
        show: _unref(isShowShareApp),
        "onUpdate:show": _cache[2] || (_cache[2] = $event => _isRef(isShowShareApp) ? isShowShareApp.value = $event : null),
        shareConfiguration: _unref(shareConfiguration)
      }, null, 8, ["style", "show", "shareConfiguration"])) : _createCommentVNode("", true), _unref(selectProductParams).showAddCart ? (_openBlock(), _createBlock(BuyingOptionsPopup, {
        key: 1,
        marginBottom: __props.cptPopupHeight,
        isAddToCart: true,
        quantity: _unref(selectProductParams).selectedCount,
        "onUpdate:quantity": _cache[3] || (_cache[3] = $event => _unref(selectProductParams).selectedCount = $event),
        isShowPopup: _unref(selectProductParams).showAddCart,
        "onUpdate:isShowPopup": _cache[4] || (_cache[4] = $event => _unref(selectProductParams).showAddCart = $event),
        promotionInfoList: couponList.value,
        selectedAsin: _unref(selectProductParams).selectedAsin,
        merchantId: _unref(selectProductParams).selectedMerchantId,
        isProductReplace: _unref(selectProductParams).isProductReplace,
        onOnConfirm: onProductOnConfirm
      }, null, 8, ["marginBottom", "quantity", "isShowPopup", "promotionInfoList", "selectedAsin", "merchantId", "isProductReplace"])) : _createCommentVNode("", true)], 64);
    };
  }
};